import React from 'react';
import PropTypes from 'prop-types';
import { ButtonRow } from './styled';
import DraftButtons from './components/DraftButtons';
import ContactUsButton from './components/ContactUsButton';
import ClaimNoteButton from './components/ClaimNoteButton';
import ClaimDownloadSummaryButton from './components/ClaimDownloadSummaryButton';

const ClaimActionButtons = ({ claim }) => {
  return (
    <ButtonRow>
      <DraftButtons claim={claim} />
      <ContactUsButton claim={claim} />
      <ClaimNoteButton claim={claim} />
      <ClaimDownloadSummaryButton claim={claim} />
    </ButtonRow>
  );
};

ClaimActionButtons.propTypes = {
  claim: PropTypes.any.isRequired
};

export default ClaimActionButtons;
